import * as React from 'react'
import { ChannelType } from 'shared/types'
import { styled } from '@mui/material/styles'

export interface ChannelIconProps {
  channelType: { Icon: string | React.ElementType }
  size?: number
}

const Container = styled('div')({
  // parent size is computed in JS
  marginRight: 10,
  '& svg': {
    width: '100%',
    height: '100%',
  },
})

export const ChannelIcon: React.FC<ChannelIconProps> = (props) => {
  const { channelType, size = 28, ...restProps } = props

  return (
    <Container
      style={{
        width: size,
        height: size,
      }}
      dangerouslySetInnerHTML={typeof channelType?.Icon === 'string' ? { __html: channelType.Icon } : undefined}
      {...restProps}
    >
      {typeof channelType?.Icon === 'function' ? (
        <channelType.Icon />
      ) : typeof channelType?.Icon === 'object' ? (
        channelType.Icon
      ) : undefined}
    </Container>
  )
}
